<template>
  <div id="app" class="app-content">
    <Navigation ></Navigation>
    <section class="main-content">
      <router-view/>
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation'
import Footer from '@/components/Footer'
import { mapState } from 'vuex'

export default {
  components: { Navigation, Footer },
  computed: {
    ...mapState(['currentUser'])
  },
  mounted () {
    // Jivo Chat
    const jivoBase = document.createElement('script')
    jivoBase.setAttribute('src', '//code.jivosite.com/widget/fr6e9tZEf1')
    document.head.appendChild(jivoBase)
  }
}
</script>
